<script setup>
import { reactiveOmit } from "@vueuse/core";
import { Primitive } from "reka-ui";
import { cn } from "@/shared/lib/utils";

const props = defineProps({
  class: { type: [String, Object, Array], default: undefined },
  as: { type: [String, Object], default: "div" },
  asChild: { type: Boolean, default: false },
});

const delegatedProps = reactiveOmit(props, "class");
</script>

<template>
  <Primitive
    v-bind="delegatedProps"
    data-slot="action-bar-body"
    :class="
      cn(
        'flex items-center gap-1 [&_[data-slot=action-bar-separator]]:h-2',
        props.class
      )
    "
  >
    <slot />
  </Primitive>
</template>
